import { AHText, AHTextFonts, useTime } from "arkh";
import React, { useMemo } from "react";

import { DateTime } from "luxon";

export function TaskDate(props: { date?: DateTime | null }) {
  const showRelative = props.date
    ? DateTime.local().endOf("day").valueOf() ===
      props.date?.endOf("day").valueOf()
    : false;
  useTime(6000, !showRelative);
  const date = useMemo(() => {
    if (!props.date) {
      return undefined;
    }
    return showRelative
      ? props.date.toRelativeCalendar() +
          " " +
          props.date.toLocaleString(DateTime.TIME_24_SIMPLE as any) ?? ""
      : props.date.toFormat("EEE d MMM");
  }, [props.date, showRelative]);

  return (
    <AHText
      style={{
        textTransform: "capitalize",
        textAlign: "center",
        flex: 0,
      }}
      font={AHTextFonts.BOLD}
      type="detail"
    >
      {date}
    </AHText>
  );
}
